export const getFlexValues = (css: Record<string, any>) => {
  const { flexGrow, flexShrink, flexBasis = '', flex = '' } = css;

  const flexArray = flex.length > 1 ? flex.split(' ') : [flex || ''];

  const flexArrayGrow = flexArray.length > 0 ? flexArray[0] : '';
  const flexArrayShrink = flexArray.length > 1 ? flexArray[1] : '';
  // 'initial' and 'none' values are translated to auto in css
  const flexArrayBasis = flexArray.length > 2 ? flexArray[2].replace(/initial|none/, 'auto') : '';

  const isShrinkUnset = typeof flexShrink === 'undefined' && !flexArrayShrink;

  const isGrowActive = flexGrow === 1 || flexArrayGrow === '1';
  const isShrinkActive = isShrinkUnset || flexShrink === 1 || flexArrayShrink === '1';
  const basisValue = flexBasis || flexArrayBasis;

  return {
    isGrowActive,
    isShrinkActive,
    basisValue,
  };
};
